import React from 'react';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';
import ReactPlaceholder from 'react-placeholder';
import { FormattedMessage } from 'i18n';
import CarouselPopularItems from './components/CarouselPopularItemsComponent';
import Placeholder from './components/Placeholder';
import chevron from 'static/icons/chevron.svg';

function PopularItemsComponent({
  items,
  title,
  hidePlaceholder,
  renderList,
  assignCarouselRef,
  onClickPrevPackage,
  onClickNextPackage,
  isAirlineLandingTemplate,
}) {
  return (
    <Root isAirlineLandingTemplate={isAirlineLandingTemplate}>
      <Title>
        <FormattedMessage
          id={title.id}
          description={title.description}
          defaultMessage={title.defaultMessage}
          values={title.values}
        />
      </Title>
      {renderList && (
        <HotelsList>
          <ReactPlaceholder ready={hidePlaceholder} showLoadingAnimation={true} customPlaceholder={<Placeholder />}>
            <CarouselPopularItems items={items} assignCarouselRef={assignCarouselRef} />
          </ReactPlaceholder>
        </HotelsList>
      )}
      <Navigation>
        <Button onClick={onClickPrevPackage} isPrev>
          <img src={chevron} alt='previous package' />
        </Button>
        <Margin right='0.5' inline={true} />
        <Button onClick={onClickNextPackage} isNext>
          <img src={chevron} alt='next package' />
        </Button>
      </Navigation>
    </Root>
  );
}

export default PopularItemsComponent;

const Root = styled.div`
  overflow-x: hidden;
  margin-bottom: ${({ isAirlineLandingTemplate }) => (isAirlineLandingTemplate ? '150px' : 'auto')};
`;

const Title = styled.h2`
  margin: 0 0 32px;
  font-family: ${({ theme }) => theme.fonts.displaySubtle};
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.default};
`;

const HotelsList = styled.div``;

const Navigation = styled.div`
  width: 88px;
  margin: 20px auto 2px;
`;

const Button = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.border.default};
  background-color: ${({ theme }) => theme.colors.background.light};
  cursor: pointer;

  img {
    width: 7px;
  }

  ${({ isPrev }) =>
    isPrev &&
    `
    img {
      position: relative;
      left: -1px;
      transform: rotate(180deg);
    }
  `}

  ${({ isNext }) =>
    isNext &&
    `
    img {
      position: relative;
      left: 1px;
    }
  `}
`;
